import React from 'react';
import TableReport from "../../../common/table/table";
import {JobCostTable} from "./jobCostTable";
import MessageEmptyData from "../../../common/messageEmptyData";
import {isEmpty} from "lodash";

/**
 * Body report component
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const JobCostBody = (prop) => {
    const {reportFilters, tableData} = prop;

    if (!reportFilters.isSubmitted) {
        return null;
    }

    if (isEmpty(tableData)) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid">
            <TableReport
                columns={JobCostTable}
                data={tableData}
                scrollable={true}
                withGlobalSearch={true}
                exportOptions={{pdf: false, xlsx: true, csv: true}}
                getExportFileName={() => 'jobCost'}
            />
        </div>
    );
}

export default JobCostBody;
